<!--
 * 组件名称
 * @description 归口福利项表格列表
 * @module src/components/underfee-column
 * @author: 张燕
 * @date: 创建时间：2022-06-24
 *
 * @prop {col:{}} [Object] 每列数据
 * @prop {tableData:[]} [Array] 整个表格数据
 * @prop {pasteField:[]} [Array] 支付粘贴复制的输入框id
 *
 * @event {() => void} [saveUnderFee] 输入框失焦事件
 *
 * @event {() => void} [modification] 同步输入回调事件
 *
 * @event {() => void} [pasteData] 复制粘贴事件
 *
 *
 *  @example 调用示例
 *  <UnderFeeColumn 
        v-for="(item,index) in tHead"
        :key="index"
        :col="item"
        :tableData="underFeeData"
        :pasteField="pasteField"
        @saveUnderFee="saveUnderFee"
        @modification="modification"
        @pasteData="pasteData"
    />
 */
-->
<template>
    <el-table-column
        :label="col.label"
        :prop="col.prop"
        align="center"
        :width="col.width"
        :show-overflow-tooltip="!col.isEdit && (col.prop == 'welfareDepartName' || col.prop == 'remark')">
        <template slot-scope="scope">
            <!-- 需要编辑的数据 -->
            <el-input
                maxlength="maxlength"
                type="text"
                v-if="col.isEdit && col.fillType == 'number'"
                placeholder="请输入"
                
                :value="strGetVal(col.prop,scope)"
                class="inputStyle"
                @blur="onBlur($event,'number')"
                @focus="getfocus($event,scope,col)"
                @paste.native="onPaste(scope.$index,col.prop)"
                v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event,'number')">
            </el-input>
            <el-input
                type="text"
                v-if="col.isEdit && col.fillType == 'text'"
                placeholder="请输入"
                :value="scope.row[col.prop]"
                class="inputStyle"
                :maxlength="col.maxLength"
                @blur="onBlur($event,'text')"
                @paste.native="onPaste(scope.$index,col.prop)"
                v-on:input="inputFunc(scope.$index, scope.row,col.prop,$event)">
            </el-input>
            <!-- 只是展示不可编辑 -->
            <div v-if="!col.isEdit && col.fillType == 'number'" class="overflowText">{{scope.row[col.prop] | money}}</div>
            <div v-if="!col.isEdit && col.fillType == 'text'" class="overflowText">{{scope.row[col.prop]}}</div>
        </template>
    </el-table-column>
</template>

<script>
    import { money, numberFormat } from "@/utils/filter.js"
    export default {
        props: {
            col: {
                type: Object
            },
            tableData:{
                type: Array,
                default: () => {
                    return []
                }
            },
            pasteField:{
                type: Array,
                default: () => {
                    return []
                }
            },
        },
        data(){
            return {
                maxlength:13, //10位整数 + 小数点 + 2位小数，所以是13位
                maxValue:"9999999999.99"
            }
        },
        methods: {
            //获取到焦点
            getfocus(e,scope,col,index){
                console.log("获取焦点============", e);
                let rowprop = eval('scope.row.'+col.prop );
                e.target.value = rowprop
            },
            // 失焦
            onBlur(e,type){
                if( type == "number" ){
                    e.target.value = this.commafy(e.target.value);
                }
                this.$emit("saveUnderFee",this.tableData);
            },
            // 同步输入
            inputFunc(index, row, prop, e,type){
                let that = this;
                if(that.tableData !=undefined){
                    if( type == "number" ){
                        e = numberFormat(e, {start: 10, end: 2});
                        eval('row.'+prop+"= e" );
                        if(Number(e)>Number(this.maxValue)){
                            this.$message("已超过最大值");
                            return
                        }
                    }else{
                        eval('row.'+prop+"= e" );
                    }
                    var new_arr = JSON.parse(JSON.stringify(that.tableData));
                    //排序出现值错乱得问题
                    new_arr[index] = row;
                    //回掉事件
                    that.$emit("modification", {index:index,row:row,prop:prop,val:e,tableData:new_arr});
                }
            },
            // 粘贴事件
            onPaste(index,prop){
                //如果不满足 黏贴列表传空pasteField=[]
                if(this.pasteField&&this.pasteField.length>0){
                    navigator.clipboard.readText().then((clipText)=>{//
                         console.log("clipText==================>",clipText)
                        if(clipText.indexOf("\r\n") > 0){
                            //1.剪贴版结果集
                            let result = this.substrClipTest(clipText,[]); 
                            let editData = []; 
                            //2.结果集处理成对象 类型，字段名，内容
                            result.forEach((value,key)=>{
                                let data = [];
                                let startVal =false,i=0;
                                this.pasteField.forEach((editValue,editKey)=>{
                                    if( Number(value[i]) > 9999999999.99 ){
                                        value[i] = 9999999999.99;
                                    }
                                    if((editValue.name == prop || startVal)&&value[i]!=undefined){//2个字段相等就开始， 直到数组遍历完
                                        startVal =true;
                                        let obj={type:editValue.type,key:editValue.name,value:value[i],isCover:editValue.isCover};
                                        data.push(obj);
                                        i++;
                                    }
                                });
                                editData.push(data);
                            });
                            console.log("结果集editData======>",editData)
                            this.tLength=this.tableData.length
                            //记录每个编辑得值。 页面只处理这些编辑得
                            let pasteDataLocal=[];
                            //3.结果集 写入到表里面
                            editData.forEach((value,key)=>{
                                value.forEach((innerValue,innerKey)=>{
                                    if(index+key<this.tLength){
                                        //每种类型的处理
                                        if(innerValue.isCover){
                                            if(innerValue.type == "number"){
                                                this.tableData[index+key][innerValue.key] = parseFloat(innerValue.value);
                                            }else if(innerValue.type == "date"){
                                                this.tableData[index+key][innerValue.key] = moment(innerValue.value).valueOf();
                                            }else{
                                                this.tableData[index+key][innerValue.key] = innerValue.value;
                                            }
                                            pasteDataLocal.push({"key":index+key,"name":innerValue.key});
                                        }
                                    }
                                    
                                });
                            });
                            //公共处理
                            this.$emit("pasteData",{tableData:this.tableData,index:index,prop:prop,result:result,pasteDataLocal:pasteDataLocal});
                        }
                    });
                }else{
                    navigator.clipboard.readText().then((clipText)=>{//
                         console.log("clipText=======>",clipText)
                        if(clipText.indexOf("\r\n") > 0){
                            //1.剪贴版结果集
                            let result = this.substrClipTest(clipText,[]); 
                            //自己处理
                            this.$emit("pasteData",{tableData:this.tableData,index:index,prop:prop,result:result});
                        }
                    });
                }
                
            },
            substrClipTest(clipText,data){
                let index = clipText.indexOf("\r\n");
                if(index > -1){
                    let rowResult = clipText.slice(0,index).split("\t");
                    data.push(rowResult);
                    let text = clipText.slice(index+2);
                    if(text.indexOf("\r\n") > -1){
                        this.substrClipTest(text,data);
                    }
                    return data;
                }
            },
            // 数字格式转换成千分位
            commafy(num){
                if((num+"").trim()=="" || isNaN(num) || num == null){
                    return num;
                }
                num = num+"";
                if(/^.*\..*$/.test(num)){
                let pointIndex =num.lastIndexOf(".");
                let intPart = num.substring(0,pointIndex);
                let pointPart =num.substring(pointIndex+1,num.length);
                intPart = intPart +"";
                    let re =/(-?\d+)(\d{3})/
                    while(re.test(intPart)){
                    intPart =intPart.replace(re,"$1,$2")
                    }
                num = intPart+"."+pointPart;
                }else{
                    num = num +"";
                    let re =/(-?\d+)(\d{3})/
                    while(re.test(num)){
                    num =num.replace(re,"$1,$2")
                    }
                }
                return num;
            },
            strGetVal(row,scope){
                return this.commafy(eval('scope.row.'+row ))
            }
        }
    }
</script>

<style lang="scss" scoped>
    .inputStyle{
        /deep/.el-input__inner{
            border: unset;
            text-align: center;
            color: #3296fa;
        }
    }
    .overflowText{
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
    }
</style>